class User {
  constructor(
    firstName,
    lastName,
    phoneNumber,
    nationalCode,
    gender,
    birthDate,
    address,
    educationDegreeId,
    expireDate,
    emailAddress,
    usePasswordPolicy,
    forceChangePassword,
    forceTwoStepAuthentication,
    password,
    passwordRepeat,
    userName,
    userRoleIds,
    userCityIds,
    userHospitalIds,
    userPermissoionIds,
    userOtherOrganizationIds,
    userPersonnelInfo,
    userStationIds,
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.phoneNumber = phoneNumber;
    this.nationalCode = nationalCode;
    this.gender = gender;
    this.birthDate = birthDate;
    this.address = address;
    this.educationDegreeId = educationDegreeId;
    this.expireDate = expireDate;
    this.emailAddress = emailAddress;
    this.usePasswordPolicy = usePasswordPolicy;
    this.forceChangePassword = forceChangePassword;
    this.forceTwoStepAuthentication = forceTwoStepAuthentication;
    this.password = password;
    this.passwordRepeat = passwordRepeat;
    this.userName = userName;
    this.userRoleIds = userRoleIds;
    this.userCityIds = userCityIds;
    this.userHospitalIds = userHospitalIds;
    this.userPermissoionIds = userPermissoionIds;
    this.userOtherOrganizationIds = userOtherOrganizationIds;
    this.userPersonnelInfo = userPersonnelInfo;
    this.userStationIds = userStationIds;
  }
}
class UserPersonnelInfo {
  constructor(personnelNumber, startDate, organizationRoleId) {
    this.personnelNumber = personnelNumber;
    this.startDate = startDate;
    this.organizationRoleId = organizationRoleId;
  }
}
class EditUserInfo {
  constructor(
    firstName,
    lastName,
    userName,
    phoneNumber,
    nationalCode,
    gender,
    birthDate,
    address,
    educationDegreeId,
    expireDate,
    emailAddress,
    usePasswordPolicy,
    forceChangePassword,
    forceTwoStepAuthentication,
    id,
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.userName = userName;
    this.phoneNumber = phoneNumber;
    this.nationalCode = nationalCode;
    this.gender = gender;
    this.birthDate = birthDate;
    this.address = address;
    this.educationDegreeId = educationDegreeId;
    this.expireDate = expireDate;
    this.emailAddress = emailAddress;
    this.usePasswordPolicy = usePasswordPolicy;
    this.forceChangePassword = forceChangePassword;
    this.forceTwoStepAuthentication = forceTwoStepAuthentication;
    this.id = id;
  }
}
import Vue from 'vue';
import notification from '../../store/NotificationHub.js';
import CryptoJS from 'crypto-js';
export default {
  inject: ['load'],
  data() {
    return {
      userManagmentInformationTableHeaders: [
        { text: 'نام و نام خانوادگی', value: 'fullName', align: 'center' },
        { text: 'کد ملی', value: 'nationalCode', align: 'center' },
        { text: 'شماره پرسنلی', value: 'personelCode', align: 'center' },
        { text: 'شماره تماس', value: 'phoneNumber', align: 'center' },
        { text: 'نام کاربری', value: 'userName', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'فعال/غیرفعال', value: 'enableDisable', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      userPaginationList: [],
      user: new User(
        '',
        '',
        '',
        '',
        null,
        '',
        '',
        null,
        '',
        '',
        false,
        false,
        false,
        '',
        '',
        '',
        [],
        [],
        [],
        [],
        [],
        new UserPersonnelInfo('', null, null),
      ),
      userPersonnelInfo: new UserPersonnelInfo('', null, null),
      userId: null,
      userDetail: {},
      allUsers: [],
      UserAllStations: [],
      editUserInfo: new EditUserInfo(
        '',
        '',
        '',
        '',
        '',
        null,
        '',
        '',
        null,
        '',
        '',
        false,
        false,
        false,
        null,
      ),
    };
  },
  methods: {
    getListOfUsersWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getUsersWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          ...this.searchFields,
        })
        .then(() => {
          if (this.$store.state.userModule.successFlag) {
            this.userPaginationList = [];
            let temp = this.$store.state.userModule.users;
            for (let i = 0; i < temp.length; i++) {
              let fullName = '';
              let status = false;
              let enableDisable = false;
              if (temp[i].firstName) {
                fullName += temp[i].firstName;
              } else {
                fullName += '-';
              }
              fullName += ' ';
              if (temp[i].lastName) {
                fullName += temp[i].lastName;
              } else {
                fullName += '-';
              }
              if (temp[i].isOnline === true) {
                status = true;
              }
              if (temp[i].isEnable === true) {
                enableDisable = true;
              }
              this.userPaginationList.push({
                fullName: fullName,
                nationalCode: temp[i].nationalCode ? temp[i].nationalCode : '-',
                personelCode: temp[i].userPersonnelInfo
                  ? temp[i].userPersonnelInfo.personnelNumber
                  : '-',
                phoneNumber: temp[i].phoneNumber ? temp[i].phoneNumber : '-',
                userName: temp[i].userName ? temp[i].userName : '-',
                status: status,
                id: temp[i].id,
                enableDisable: enableDisable,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.userModule.totalPages);

            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.userModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.userModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.userModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfUsersWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.userModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfUsersWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPages: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPages(totalPages);
      }
    },
    getAllUsersFunction: function (params) {
      this.$store.dispatch('getAllUsers', params).then(() => {
        if (this.$store.state.userModule.successFlag) {
          let data = this.$store.state.userModule.allUsers;
          data.forEach((c) => (c.fullName = c.firstName + ' ' + c.lastName));
          this.allUsers = data;
        } else {
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllUsersFunction(params);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllUsersFunction(params);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addUserFunction: function () {
      /*if (this.allUserSelectedPermissions.length == 0) {
                this.snackText = "لطفا سطح دسترسی را وارد نمایید.";
                this.$refs.snackRef.snackModel = true;
                this.snackColor = "#FF5252";
                this.snakIcon = "mdi-information";
                this.disabelConfirm = false;
                return;
            }*/
      this.user.userRoleIds = [];
      this.user.userPermissoionIds = [];
      for (let i = 0; i < this.allUserSelectedRoles.length; i++) {
        this.user.userRoleIds.push(Number(this.allUserSelectedRoles[i].id));
      }
      for (let i = 0; i < this.allUserSelectedPermissions.length; i++) {
        this.user.userPermissoionIds.push(Number(this.allUserSelectedPermissions[i].id));
      }
      if (!this.user.birthDate) {
        this.user.birthDate = null;
      }
      if (!this.user.expireDate) {
        this.user.expireDate = null;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addUser', this.user).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.user = new User(
            '',
            '',
            '',
            '',
            null,
            '',
            '',
            null,
            '',
            '',
            false,
            false,
            false,
            '',
            '',
            '',
            [],
            [],
            [],
            [],
            [],
            new UserPersonnelInfo('', null, null),
          );
          this.$router.push({ name: 'user' });
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getUserDetailFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUserDetail', id).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.userDetail = this.$store.state.userModule.userDetail;
          if (this.$route.name == 'detailUser') {
            this.makeDataReady(this.userDetail);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserDetailFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getUserFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUser', id).then(() => {
        if (this.$store.state.userModule.successFlag) {
          let temp = this.$store.state.userModule.user;
          if (this.$route.name == 'editUser') {
            this.makeDataReady(temp);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getUserProfileFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUserProfile').then(() => {
        if (this.$store.state.userModule.successFlag) {
          let temp = this.$store.state.userModule.userProfile;
          if (this.$route.name == 'profile') {
            this.makeDataReady(temp);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserProfileFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserProfileFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserFunction: function () {
      if (!this.editUserInfo.birthDate) {
        this.editUserInfo.birthDate = null;
      }
      if (!this.editUserInfo.expireDate) {
        this.editUserInfo.expireDate = null;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editUser', this.editUserInfo).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.editUserInfo = new EditUserInfo(
            '',
            '',
            '',
            '',
            null,
            '',
            '',
            null,
            '',
            '',
            false,
            false,
            false,
            null,
          );
          this.$router.push({ name: 'user' });
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    // userStation
    getUserAllStations: function (userId) {
      const params = {
        userId,
      };
      this.load.val = true;
      this.$store
        .dispatch('getUserAllStationsDispatch', params)
        .then(() => {
          if (this.$store.state.userModule.successFlag) {
            const data = this.$store.state.userModule.userStations;
            this.UserAllStations = data;
          } else {
            if (this.$store.state.userModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getUserAllStations(userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.userModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getUserAllStations(userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    setUserStations: function (body, onsuccess) {
      this.load.val = true;
      this.$store
        .dispatch('setUserStationsDispatch', body)
        .then(() => {
          if (this.$store.state.userModule.successFlag) {
            this.showSuccessAlert('پایگاه های کاربر بروزرسانی شد.');
            onsuccess();
          } else {
            if (this.$store.state.userModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.setUserStations(body, onsuccess);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.userModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.setUserStations(body, onsuccess);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    // end userStation
    getUserOtherOrganizationList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('userOtherOrganizations', this.userId).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.$route.name == 'user') {
            this.allUserSelectedOtherOrganizations =
              this.$store.state.userModule.userOtherOrganizations;
            this.defineUserOtherOrganization();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserOtherOrganizationList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserOtherOrganizationList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserOtherOrganizationFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userId: this.userId,
        features: [],
      };
      for (let i = 0; i < this.allUserSelectedOtherOrganizations.length; i++) {
        data.features.push(Number(this.allUserSelectedOtherOrganizations[i].id));
      }
      this.$store.dispatch('editUserOtherOrganization', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' سازمان های همکار کاربر با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allUserSelectedOtherOrganizations = [];
          this.allUserOtherOrganizations = [];
          this.otherOrganizationModal = false;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //permission part
    getUserPermissionList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('userPrmissions', this.userId).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.$route.name == 'user') {
            this.allUserSelectedPermissions = this.$store.state.userModule.userPermisions;
            this.defineUserPermissions();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserPermissionList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserPermissionList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserPermissionFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userId: this.userId,
        features: [],
      };
      for (let i = 0; i < this.allUserSelectedPermissions.length; i++) {
        data.features.push(Number(this.allUserSelectedPermissions[i].id));
      }
      this.$store.dispatch('editUserPermission', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' سطح های دسترسی کاربر با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allUserSelectedPermissions = [];
          this.allUserPermissions = [];
          this.permissionModal = false;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserPermissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserPermissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //role part
    getUserRoleList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('userRoles', this.userId).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.$route.name == 'user') {
            this.allUserSelectedRoles = this.$store.state.userModule.userRoles;
            this.defineUserRoles();
          }
          if (
            this.$route.name == 'qcUsersForQCReport' ||
            this.$route.name == 'qcUser115Dashboard' ||
            this.$route.name == 'qcUser800Dashboard' ||
            this.$route.name == 'qcUserTechnicianDashboard' ||
            this.$route.name == 'qcUserDoctorDashboard'
          ) {
            this.userAllRoles = this.$store.state.userModule.userRoles;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserRoleList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserRoleList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserRoleFunction: function () {
      if (this.allUserSelectedRoles.length == 0) {
        this.snackText = 'انتخاب حداقل یک نقش اجباری است.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userId: this.userId,
        features: [],
      };
      for (let i = 0; i < this.allUserSelectedRoles.length; i++) {
        data.features.push(Number(this.allUserSelectedRoles[i].id));
      }
      this.$store.dispatch('editUserRole', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' نقش های کاربر با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allUserSelectedRoles = [];
          this.allUserRoles = [];
          this.roleModal = false;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //city part
    getUserCityList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('userCitys', this.userId).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.$route.name == 'user') {
            this.allUserSelectedCitys = this.$store.state.userModule.userCitys;
            this.defineUserCitys();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserCityList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserCityList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserCityFunction: function () {
      if (this.allUserSelectedCitys.length == 0) {
        this.snackText = 'انتخاب حداقل یک شهرستان اجباری است.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userId: this.userId,
        features: [],
      };
      for (let i = 0; i < this.allUserSelectedCitys.length; i++) {
        data.features.push(Number(this.allUserSelectedCitys[i].id));
      }
      this.$store.dispatch('editUserCity', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' شهرستان های کاربر با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allUserSelectedCitys = [];
          this.allUserCitys = [];
          this.cityModal = false;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserCityFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //hospital part
    getUserHospitalList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('userHospitals', this.userId).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.$route.name == 'user') {
            this.allUserSelectedHospitals = this.$store.state.userModule.userHospitals;
            this.defineUserHospitals();
          }
          if (this.$route.name == 'hospitalMissions') {
            this.allUserHospitals = this.$store.state.userModule.userHospitals;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserHospitalList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserHospitalList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserHospitalFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userId: this.userId,
        features: [],
      };
      for (let i = 0; i < this.allUserSelectedHospitals.length; i++) {
        data.features.push(Number(this.allUserSelectedHospitals[i].id));
      }
      this.$store.dispatch('editUserHospital', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' بیمارستان های کاربر با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allUserSelectedHospitals = [];
          this.allUserHospitals = [];
          this.hospitalModal = false;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //enableDisable
    deActiveUserFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deactiveUser', this.userId).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$root.$refs.confirmDialog.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'کاربر با موفقیت غیر فعال شد ';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deActiveUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deActiveUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    activeUserFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('activeUser', this.userId).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$root.$refs.confirmDialog.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'کاربر با موفقیت فعال شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.activeUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.activeUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //set password
    setUserPasswordFunction: function () {
      if (!this.setUserPassword) {
        this.snackText = 'لطفا کلمه عبور را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.setUserPassword != this.setUserPasswordRepeat) {
        this.snackText = 'کلمه عبور با تکرار آن برابر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        password: this.setUserPassword,
        passwordRepeat: this.setUserPasswordRepeat,
        id: this.userId,
      };
      this.$store.dispatch('setPasswordForUser', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.disabelConfirm = false;
          this.$root.$refs.confirmDialog.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.setUserPassword = '';
          this.setUserPasswordRepeat = '';
          this.changeUserPasswordModal = false;
          this.snackText = 'رمز عبور کاربر با موفقیت تغییر یافت';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setUserPasswordFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setUserPasswordFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    uploadImagefunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      const fd = new FormData();
      fd.append('image', this.img, this.img.name);
      this.$store.dispatch('changeImage', fd).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.snackText = 'تصویر با موفقیت اصلاح شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.getUserProfileFunction();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.uploadImagefunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.uploadImagefunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editCurrentUserFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editCurrentUser', this.userProfile).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.disabelConfirm = false;
          this.$root.$refs.confirmDialog.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.editCurrentUserModal = false;
          this.snackText = 'اطلاعات با موفقیت تغییر یافت';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.getUserProfileFunction();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editCurrentUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editCurrentUserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    changeCurrentUserPasswordFunction: function () {
      if (!this.currentPassword) {
        this.snackText = 'لطفا کلمه عبور قبلی را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.newPassword) {
        this.snackText = 'لطفا کلمه عبور جدید را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.newPassword != this.newPasswordRepeat) {
        this.snackText = 'کلمه عبور جدید با تکرار آن برابر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        password: this.newPassword,
        passwordRepeat: this.newPasswordRepeat,
        oldPassword: this.currentPassword,
      };
      this.$store.dispatch('changeCurrentUserPassword', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.disabelConfirm = false;
          this.$root.$refs.confirmDialog.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.currentPassword = '';
          this.newPassword = '';
          this.newPasswordRepeat = '';
          this.currentUserChangePasswordModal = false;
          this.snackText = 'رمز عبور با موفقیت تغییر یافت';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.changeCurrentUserPasswordFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.changeCurrentUserPasswordFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setExtensionFunction: function (extension) {
      this.$store.dispatch('setExtension', extension.id).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          localStorage.setItem('extension', extension.sipExtension);
          notification.install(Vue);
          this.checkForLoginUser();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setExtensionFunction(extension);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setExtensionFunction(extension);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setZoneFunction: function (zone) {
      this.$store.dispatch('setZone', zone.id).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          //localStorage.setItem("zone", zone.title);
          this.checkForLogin800User();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setZoneFunction(zone);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setZoneFunction(zone);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //otp
    otpRequestForForgetPasswordFunction: function (phoneNumber) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('otpRequest', phoneNumber).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.successForgetPasswordOtpRequest();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.otpRequestForForgetPasswordFunction(phoneNumber);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.otpRequestForForgetPasswordFunction(phoneNumber);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    otpVerifyForForgetPasswordFunction: function (phoneNumber, token) {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        phoneNumber: phoneNumber,
        token: token,
      };
      this.$store.dispatch('oTPVerify', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.successForgetPasswordOtpVerify();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.otpVerifyForForgetPasswordFunction(phoneNumber, token);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.otpVerifyForForgetPasswordFunction(phoneNumber, token);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setOTPChangePasswordFunction: function (password, repeatPassword) {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        password: password,
        passwordRepeat: repeatPassword,
      };
      this.$store.dispatch('oTPChangePassword', data).then(() => {
        if (this.$store.state.userModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.$store.dispatch('csrf').then(() => {
            if (this.$store.state.loginModule.successFlag) {
              this.$store.dispatch('getUserCurrent').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  if (this.load.val) {
                    this.load.val = false;
                  }
                  this.user = new User('', '');
                  let temp = this.$store.state.userModule.user;
                  if (temp.roles.length === 1) {
                    if (temp.roles[0].englishTitle == 'Admin') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      this.$router.push({ name: 'user' });
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('blue');
                    } else if (temp.roles[0].englishTitle == 'User115') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      this.make115UserReadyForLogin();
                    } else if (temp.roles[0].englishTitle == 'User800') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      this.make800UserReadyForLogin();
                    } else if (temp.roles[0].englishTitle == 'Admission') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      this.makeAdmissionUserReadyForLogin();
                    } else if (temp.roles[0].englishTitle == 'EOC') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      this.make800UserReadyForLogin();
                    }
                  } else if (temp.roles.length > 1) {
                    this.$router.push({ name: 'module' });
                  } else {
                    this.snackText = this.$store.state.loginModule.error;
                    this.$refs.snackRef.snackModel = true;
                    this.snackColor = '#FF5252';
                    this.snakIcon = 'mdi-information';
                  }
                }
              });
            }
          });
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setOTPChangePasswordFunction(password, repeatPassword);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setOTPChangePasswordFunction(password, repeatPassword);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getUserCurrentAttemptForProfile: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getCurrentAttempt').then(() => {
        if (this.$store.state.userModule.successFlag) {
          let temp = this.$store.state.userModule.userProfileAttempt;
          if (this.$route.name == 'profile') {
            this.makeReadyAttemptData(temp);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserCurrentAttemptForProfile();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserCurrentAttemptForProfile();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllTechniciansFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllTechnicians').then(() => {
        if (this.$store.state.userModule.successFlag) {
          let temp = this.$store.state.userModule.allTechnicians;
          if (this.$route.name == 'followUpMission') {
            this.technesiansList = [];
            for (let i = 0; i < temp.length; i++) {
              let fName = temp[i].firstName;
              let lName = temp[i].lastName;
              let user = fName + ' ' + lName;
              this.technesiansList.push({
                fullName: user,
                personelNumber: temp[i].nationalCode ? temp[i].nationalCode : '-',
                phoneNumber: temp[i].phoneNumber ? temp[i].phoneNumber : '-',
                id: temp[i].id,
                technecianCode: temp[i].personnelNumber ? temp[i].personnelNumber : '-',
              });
            }
          }
          if (this.$route.name == 'qcAllCheckLists' || this.$route.name == 'refuelReportAmar') {
            this.technesiansList = [];
            for (let i = 0; i < temp.length; i++) {
              let fName = temp[i].firstName;
              let lName = temp[i].lastName;
              let user = fName + ' ' + lName;
              this.technesiansList.push({ fullName: user, id: temp[i].id });
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllTechniciansFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllTechniciansFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.userModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
